import React, { useState, useMemo } from "react";
import useSWR from "swr";
import { useNavigate, useLocation } from "react-router-dom";
import {
  DataGrid,
  Lookup,
  Column,
  Button,
  StringLengthRule,
  Editing,
  Scrolling,
  Texts,
  SearchPanel,
  Popup,
  Form,
  Item,
  Toolbar,
} from "devextreme-react/data-grid";
import { Popup as MyPopup } from "devextreme-react/popup";
import { Button as MyButton } from "devextreme-react/button";
import ScrollView from "devextreme-react/scroll-view";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import LoadingSpinnerModal from "../../Components/LoadingSpinnerModal";
import { apiBaseURL } from "../../Utils/ProjectConstants";
import useFetch from "../../Hooks/useFetch";
import { checkRoles } from "../../Utils/helper";
import { isMobile } from "../../Utils/media-query";
import ActionNotifications from "../../Components/ActionNotifications";
import FileUploader from "devextreme-react/file-uploader";
import ErrorMessage from "../../Components/ErrorMessage";
import { putWorkCenter } from "../../Utils/handlePUT/handlePutWorkCenter";
import handlePostWorkCenter from "../../Utils/handlePOST/handlePostWorkCenter";
import "./styles.css";
import { useRef } from "react";
library.add(fas);

const operationTypes = [
  { label: "Research", value: 0 },
  { label: "Operation", value: 1 },
];
export default function WorkCentersPage() {
  const imageFileRef = useRef(null);
  const navigate = useNavigate(),
    fetch = useFetch(navigate),
    location = useLocation(),
    [notifyResponse, setResponse] = useState({}),
    [showSpinner, setSpinner] = useState(false),
    [showPopup, setPopup] = useState(
      location?.state?.popup ? "Create Tasks" : ""
    ),
    { data, mutate, error } = useSWR(`${apiBaseURL}/api/WorkCenter`),
    locations = useMemo(() => {
      return data?.data?.map((x) => ({
        id: x.id,
        name: x.name,
        numberOfFulltimes: x.numberOFFulltimes,
        numberOfStudents: x.numberOfStudents,
        type: x.type,
        tasks: x.tasks.length > 0 ? x.tasks.map((x) => x.id) : [],
        woTableName: x.woTableName,
        woMachineName: x.woMachineName,
        operationHours: x.operationHours,
        workCenterMeasurables: x.workCenterMeasurables,
        imageUrl: x.imageUrl || x.ImageUrl || "",
      }));
    }, [data]),
    {
      data: taskData,
      error: taskError,
      mutate: workTaskMutate,
    } = useSWR(`${apiBaseURL}/api/WorkTasks`),
    allTasks = taskData?.data,
    {
      data: operationData,
      error: operationError,
      mutate: operationMutate,
    } = useSWR(`${apiBaseURL}/api/Operations`),
    allOperations = useMemo(() => {
      return operationData?.data?.map((x) => ({
        label: x.name,
        value: x.id,
        tasks: (x.tasks || []).map((task) => task.id),
        workCenter: x.workCenter.id,
      }));
    }, [operationData]);

  const fetchSuccessful = (response) => {
    setResponse(response);
    return (
      response?.success &&
      response?.data?.statusCode &&
      response?.success !== "Invalid Model"
    );
  };


  const onShowPopup = () => {
    if (showPopup === "Create Tasks") {
      const onSaved = async (e) => {
        setSpinner(true);
        console.log(e);
        let response = null;
        let editType = e.changes.find((x) => x.type === "update");
        let addType = e.changes.find((x) => x.type === "insert");

        console.log(editType);
        console.log(addType);
        if (editType) {
          const editBody = {
            id: editType.data.id,
            name: editType.data.name,
            capacityFactor: editType.data.capacityFactor,
            businessDays: editType.data.businessDays,
            WOCorelationID: editType.data.WOCorelationID,
          };
          response = await fetch.put(`${apiBaseURL}/api/WorkTasks`, editBody);
        } else if (addType) {
          const addBody = {
            name: addType.data.name,
            capacityFactor: addType.data.capacityFactor,
            businessDays: addType.data.businessDays,
            WOCorelationID: addType.data.WOCorelationID, //not working yet
          };
          response = await fetch.post(`${apiBaseURL}/api/WorkTasks`, addBody);
        }

        if (fetchSuccessful(response)) {
          workTaskMutate();
        }
        setSpinner(false);
      };

      return (
        <MyPopup
          visible={true}
          onHiding={() => setPopup("")}
          hideOnOutsideClick={true}
          showTitle={false}
          fullScreen={isMobile}
          width="75%"
          height="80%"
          resizeEnabled={true}
        >
          <ScrollView height="100%" width="100%">
            <DataGrid
              dataSource={allTasks}
              keyExpr="id"
              columnAutoWidth={true}
              onRowRemoved={onRowRemoved}
              onSaved={onSaved}
            >
              <Editing
                mode="row"
                allowUpdating={true}
                allowAdding={true}
                allowDeleting={true}
                selectTextOnEditStart={true}
                startEditAction="click"
              />
              <Column type="buttons">
                <Button
                  text="Task Rates"
                  icon="money"
                  visible={checkRoles(6) ? true : false}
                  onClick={(params) =>
                    navigate(`/workCenters/${params.row.key}`, {
                      state: { name: params.row.data.name },
                    })
                  }
                />
                <Button name="edit" visible={checkRoles(6)} />
                <Button name="delete" visible={checkRoles(6)} />
              </Column>
              <Column dataField="name" caption="Task" />
              <Column dataField="capacityFactor" />
              <Column dataField="businessDays" />
              <Column dataField="woTableName" />
            </DataGrid>
          </ScrollView>
        </MyPopup>
      );
    } else if (showPopup === "Create Operations") {
      const onSaved = async (e) => {
        setSpinner(true);

        console.log(e);
        let response = null;
        let editType = e.changes.find((x) => x.type === "update");
        let addType = e.changes.find((x) => x.type === "insert");

        console.log(editType);
        console.log(addType);
        if (editType) {
          const editBody = {
            id: editType.data.id,
            name: editType.data.label,
            workTasks: editType.data.tasks,
            workCenterId: editType.data.workCenter,
          };
          response = await fetch.put(`${apiBaseURL}/api/Operations`, editBody);
        } else if (addType) {
          const addBody = {
            name: addType.data.label, //doesn't add name
            workTasks: addType.data.tasks,
            workCenterId: addType.data.workCenter,
          };
          response = await fetch.post(`${apiBaseURL}/api/Operations`, addBody);
        }

        if (fetchSuccessful(response)) {
          operationMutate();
        }
        setSpinner(false);
      };

      const cellTemplate = (container, options) => {
        const noBreakSpace = "\u00A0";
        const text = (options.value || [])
          .map((element) => options.column.lookup.calculateCellValue(element))
          .join(", ");
        container.textContent = text || noBreakSpace;
        container.title = text;
      };

      return (
        <MyPopup
          visible={true}
          onHiding={() => setPopup("")}
          hideOnOutsideClick={true}
          showTitle={false}
          fullScreen={isMobile}
          width="75%"
          height="80%"
          resizeEnabled={true}
        >
          <ScrollView height="100%" width="100%">
            <DataGrid
              dataSource={allOperations}
              keyExpr="value"
              columnAutoWidth={true}
              onEditorPreparing={onEditorPreparing}
              onRowRemoved={onRowRemoved}
              onSaved={onSaved}
              wordWrapEnabled={true}
            >
              <Editing
                mode="row"
                allowUpdating={true}
                allowAdding={true}
                allowDeleting={true}
                selectTextOnEditStart={true}
                startEditAction="click"
              />
              <Column dataField="label" caption="Operation" />
              <Column dataField="workCenter">
                <Lookup
                  dataSource={locations}
                  valueExpr="id"
                  displayExpr="name"
                />
              </Column>
              <Column dataField="tasks" cellTemplate={cellTemplate} width="50%">
                <Lookup
                  dataSource={allTasks}
                  valueExpr="id"
                  displayExpr="name"
                />
              </Column>
            </DataGrid>
          </ScrollView>
        </MyPopup>
      );
    }
  };

  const onRowPrepared = (e) => {
    if (e.rowType === "header") {
      e.rowElement.style.backgroundColor = "#FFCD00";
      e.rowElement.style.fontWeight = "bold";
    }
  };

  const onEditorPreparing = (e) => {
    if (
      (e.parentType === "dataRow" || e.parentType === "filterRow") &&
      e.dataField === "tasks"
    ) {
      e.editorName = "dxTagBox";
      e.editorOptions.dataSource = allTasks;
      e.editorOptions.showSelectionControls = true;
      e.editorOptions.displayExpr = "name";
      e.editorOptions.valueExpr = "id";
      e.editorOptions.value = e.value || [];
      //e.editorOptions.customItemCreateEvent;
      e.editorOptions.onValueChanged = (x) => {
        //replace?
        console.log(x);
        e.setValue(x.value);
      };
    }
  };

  const onRowRemoved = async (e) => {
    console.log(e);
    let response = await fetch.delete(
      `${apiBaseURL}/api/WorkTasks?id=${e.key.id}`
    );
    //delete only works if these values are not null or 0       //!!!CONFIRM IF DELETE STILL WORKS
    if (e.data.locCode) {
      response = await fetch.delete(
        `${apiBaseURL}/api/WorkCenter?id=${e.data.id}`
      );
    } else if (e.data.capacityFactor) {
      response = await fetch.delete(
        `${apiBaseURL}/api/WorkTasks?id=${e.key.id}`
      );
    } else if (e.data.tasks) {
      response = await fetch.delete(`${apiBaseURL}/api/Operations?id=${e.key}`);
    }

    if (fetchSuccessful(response)) {
      //how does this work
      if (e.data.name) {
        mutate();
      } else if (e.data.capacityFactor) {
        workTaskMutate();
      } else if (e.data.tasks) {
        operationMutate();
      }
    }
  };

  const renderGrid = () => {
    const isButtonVisible = (e) => {
      if (e.row.data.type === 1) {
        return true;
      }
      return false;
    };

    const cellTemplate = (container, options) => {
      const noBreakSpace = "\u00A0";
      const text = (options.value || [])
        .map((element) => options.column.lookup.calculateCellValue(element))
        .join(", ");
      container.textContent = text || noBreakSpace;
      container.title = text;
    };

    const allowEditing = async (e) => {
      setSpinner(true);
      try {
        let editType = e.changes.find((x) => x.type === "update");
        let addType = e.changes.find((x) => x.type === "insert");

        if (editType) {
          const row = { ...editType.data };
          if (imageFileRef.current) row.__imageFile = imageFileRef.current;

          const { response } = await putWorkCenter(fetch, row); // pass useFetch client

          if (!response?.success) throw new Error("Update failed");
          const saved = response?.payload ?? {};

          editType.data.id = saved?.id ?? row.id;
          editType.data.imageUrl =
            saved?.imageUrl ??
            saved?.ImageUrl ??
            editType.data.imageUrl ??
            null;
        }

        if (addType) {
          const row = { ...addType.data };
          if (imageFileRef.current) row.__imageFile = imageFileRef.current;

          const { response } = await handlePostWorkCenter(fetch, row); // pass useFetch client


          if (!response?.success) throw new Error("Create failed");
          const saved = response?.payload ?? {};

          addType.data.id = saved?.id ?? addType.data.id;
          addType.data.imageUrl = saved?.imageUrl ?? saved?.ImageUrl ?? null;
        }
        imageFileRef.current = null;

        mutate(); // refresh grid
      } catch (err) {
        console.error(err);
      } finally {
        setSpinner(false);
      }
    };

    const onSaving = (e) => {
      // If the user only picked an image, DevExtreme might think "no changes"
      if (e.changes.length === 0 && imageFileRef.current) {
        const rowKey = e.component
          .getVisibleRows()
          .find((r) => r.isEditing)?.key;
        if (rowKey != null) {
          e.changes.push({
            type: "update",
            key: rowKey,
            data: { _imageTick: Date.now() },
          });
        }
      }
    };

    return (
      <>
        <DataGrid
          dataSource={locations}
          rowAlternationEnabled={false}
          showBorders={true}
          height="80vh"
          allowColumnResizing={true}
          columnAutoWidth={true}
          onEditorPreparing={onEditorPreparing}
          onSaving={onSaving}
          onSaved={allowEditing}
          //onRowRemoved={onRowRemoved}
          onRowPrepared={onRowPrepared}
          wordWrapEnabled={true}
        >
          <SearchPanel
            visible={true}
            maxWidth={275}
            searchVisibleColumnsOnly={true}
            placeholder="Search..."
          />
          <Toolbar>
            <Item
              location="before"
              locateInMenu="never"
              render={() => (
                <div className="misc-costs-title">
                  <h1 className="white">Work Centers</h1>
                </div>
              )}
            />
            <Item locateInMenu="auto">
              <MyButton
                text="Create Operations"
                type="normal"
                stylingMode="contained"
                onClick={() => setPopup("Create Operations")}
              />
            </Item>
            <Item locateInMenu="auto">
              <MyButton
                text="Create Tasks"
                type="normal"
                stylingMode="contained"
                onClick={() => setPopup("Create Tasks")}
              />
            </Item>
            <Item name="addRowButton" />
            <Item name="searchPanel" />
          </Toolbar>
          <Scrolling mode="virtual" />
          <Editing
            allowAdding={checkRoles(6)}
            allowUpdating={checkRoles(6)}
            allowDeleting={checkRoles(6)}
            mode="popup"
          >
            <Popup
              title="Work Center Info"
              showTitle={true}
              fullScreen={isMobile}
              width="50%"
              height="auto"
            />
            <Form>
              <Item itemType="group" colCount={2} colSpan={2}>
                <Item dataField="name" colSpan={2} isRequired={true} />
                <Item dataField="tasks" colSpan={2} isRequired={true} />
                <Item dataField="numberOfFulltimes" isRequired={true} />
                <Item dataField="numberOfStudents" isRequired={true} />
                <Item dataField="type" colSpan={2} isRequired={true} />
                {/* NEW: upload file (kept as __imageFile until saved) */}
                <Item
                  label={{ text: "Image (upload)" }}
                  render={(formItem) => {
                    const fd = formItem?.formData || (formItem.formData = {});
                    return (
                      <FileUploader
                        accept="image/*"
                        multiple={false}
                        uploadMode="useForm"
                        showFileList={true}
                        selectButtonText="Select a file"
                        onValueChanged={(e) => {
                          const file = Array.isArray(e.value)
                            ? e.value[0]
                            : e.value || null;
                          fd.__imageFile = file;
                          imageFileRef.current = file;
                          formItem.component.updateData(
                            "_imageTick",
                            Date.now()
                          );
                        }}
                      />
                    );
                  }}
                  colSpan={2}
                />
                <Item dataField="_imageTick" visible={false} />
              </Item>
            </Form>
            <Texts confirmDeleteMessage="Deleting clears all the hour records for this work center. Do you want to continue?" />
          </Editing>

          <Column type="buttons">
            <Button
              text="Reporting Parameters"
              icon="info"
              //visible={checkRoles(6) ? isButtonVisible : false}
              visible={false}
              onClick={(params) =>
                navigate(`/workCenters/reporting/${params.row.data.name}`, {
                  state: { labData: params.row.data },
                })
              }
            />
            <Button name="edit" visible={checkRoles(6)} />
            <Button name="delete" visible={false /*checkRoles(6)*/} />
          </Column>
          <Column dataField="name" />
          <Column dataField="tasks" width={550} cellTemplate={cellTemplate}>
            <Lookup dataSource={allTasks} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="numberOfFulltimes" caption="Fulltime" />
          <Column dataField="numberOfStudents" caption="Students" />
          <Column dataField="type" alignment="left">
            <Lookup
              dataSource={operationTypes}
              valueExpr="value"
              displayExpr="label"
            />
          </Column>
        </DataGrid>
      </>
    );
  };

  if (
    !(data || error || operationData || operationError || taskData || taskError)
  )
    return <LoadingSpinnerModal show />;

  return (
    <div className="px-lg-4 content">
      {onShowPopup()}
      <ActionNotifications response={notifyResponse} />
      <LoadingSpinnerModal show={showSpinner} />
      <div className="px-2 page-content">
        <div className="contentBox my-3">
          {!error ? renderGrid() : <ErrorMessage />}
        </div>
      </div>
    </div>
  );
}
